import i18n from './index';

export function getCurrentLanguageDisplayCode() {
  return i18n.language.substr(0, 2).toUpperCase();
}
